function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M3.96 6h39v22h-39z",
  fill: "#a5d6a7"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M3.96 28h40V6h-40zm38-20v18h-36V8z",
  fill: "#388e3c"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.96 15a2 2 0 100 4 2 2 0 100-4zm24 0a2 2 0 100 4 2 2 0 100-4zm-12-5a7 7 0 100 14 7 7 0 100-14zm14.779-3a2.978 2.978 0 00-.78 2 3 3 0 003 3c.773 0 1.469-.3 2-.779V7zM9.18 7H4.96v4.221a2.978 2.978 0 002 .779 3 3 0 003-3c0-.772-.3-1.468-.78-2zm0 20a2.978 2.978 0 00.779-2 3 3 0 00-3-3c-.772 0-1.468.3-2 .779V27zm33.779 0v-4.221a2.978 2.978 0 00-2-.779 3 3 0 00-3 3c0 .772.3 1.468.779 2z",
  fill: "#388e3c"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M14.047 28.214h12.722v5.418H14.047z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M17.338 26.047h3.251v5.9h-3.251z"
});

var Svg7100Bill = function Svg7100Bill(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 48 34.033",
    width: 344,
    height: 243.906,
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(Svg7100Bill, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/7-100-bill.06f457fa.svg";
export { ForwardRef as ReactComponent };